import { supabase } from '../../lib/supabaseClient';

export interface MessageReaction {
  id: string;
  message_id: string;
  collaborator_id: string;
  emoji: string;
  created_at: string;
  collaborator?: { id: string; full_name: string; avatar_url: string | null };
}

export const QUICK_PICK_EMOJIS = ['👍', '❤️', '😂', '✅', '🎉', '👀', '❓', '🙏'] as const;

export async function getReactionsForMessages(
  messageIds: string[],
): Promise<Map<string, MessageReaction[]>> {
  const result = new Map<string, MessageReaction[]>();
  if (messageIds.length === 0) return result;

  const { data, error } = await supabase
    .from('message_reactions')
    .select('*, collaborator:collaborators!message_reactions_collaborator_id_fkey(id, full_name, avatar_url)')
    .in('message_id', messageIds)
    .order('created_at', { ascending: true });

  if (error) throw error;

  for (const row of (data ?? []) as MessageReaction[]) {
    const list = result.get(row.message_id) ?? [];
    list.push(row);
    result.set(row.message_id, list);
  }

  return result;
}

export async function addReaction(messageId: string, emoji: string, collaboratorId: string): Promise<void> {
  const { error } = await supabase.from('message_reactions').insert({
    message_id: messageId,
    collaborator_id: collaboratorId,
    emoji,
  });
  // 23505 = unique_violation : réaction déjà présente → no-op
  if (error && error.code !== '23505') throw error;
}

export async function removeReaction(messageId: string, emoji: string, collaboratorId: string): Promise<void> {
  const { error } = await supabase
    .from('message_reactions')
    .delete()
    .eq('message_id', messageId)
    .eq('collaborator_id', collaboratorId)
    .eq('emoji', emoji);
  if (error) throw error;
}
